/* TableComponent.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _24 = "._1hjn1e5h:first-of-type{text-align:left}";
const _23 = "._19hhidpf:first-of-type{border-left:0}";
const _22 = "._y3gn1h6o{text-align:center}";
const _21 = "._1wpz1fhb{align-self:stretch}";
const _20 = "._1kl7zgxb{border-left:1px solid var(--ds-border,#091e4224)}";
const _19 = "._1yt49l6b{padding:var(--ds-space-150,9pt) var(--ds-space-200,1pc)}";
const _18 = "._1kepni7l:first-of-type{font-weight:600}";
const _17 = "._14t0idpf:first-of-type{border-top:0}";
const _16 = "._9bsr11bn:first-of-type{background:var(--ds-background-accent-gray-subtlest,#f1f2f4)}";
const _15 = "._1wyb1j6v{font-size:1rem}";
const _14 = "._1e0c1txw{display:flex}";
const _13 = "._x3dozgxb{border-top:1px solid var(--ds-border,#091e4224)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _12 = "._18m915vq{overflow-y:hidden}";
const _11 = "._1reo15vq{overflow-x:hidden}";
const _10 = "._19bvidpf{padding-left:0}";
const _9 = "._n3tdidpf{padding-bottom:0}";
const _8 = "._u5f3idpf{padding-right:0}";
const _7 = "._ca0qidpf{padding-top:0}";
const _6 = "._18u0idpf{margin-left:0}";
const _5 = "._otyridpf{margin-bottom:0}";
const _4 = "._2hwxidpf{margin-right:0}";
const _3 = "._19pkidpf{margin-top:0}";
const _2 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _ = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
export const Table = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkou2gc _19itzgxb _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Table.displayName = 'Table';
}
export const TableRow = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _13, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3dozgxb _1e0c1txw _1wyb1j6v _9bsr11bn _14t0idpf _1kepni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TableRow.displayName = 'TableRow';
}
export const TableCell = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _21, _22, _23, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt49l6b _1kl7zgxb _1wpz1fhb _y3gn1h6o _19hhidpf _1hjn1e5h", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TableCell.displayName = 'TableCell';
}